/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Logo from '../assets/logo/logo.png';

export default function ResetError({ errorMessage, onBackToLogin }) {

  const handleBackToLogin = () => {
    if (onBackToLogin) {
      onBackToLogin();
    }
  };

  // Default error messages based on common errors
  const getErrorDetails = () => {
    if (errorMessage?.includes('expired')) {
      return {
        title: 'Invalid or Expired Reset Link',
        message: 'This password reset link is invalid or has expired. Please request a new password reset link.',
      };
    }
    if (errorMessage?.includes('already been used')) {
      return {
        title: 'Link Already Used',
        message: 'This reset link has already been used. If you need to reset your password again, please request a new link.',
      };
    }
    // if (errorMessage?.includes('Invalid')) {
    //   return {
    //     title: 'Invalid Reset Link',
    //     message: 'This password reset link is invalid. Please check your email and try again, or request a new link.',
    //   };
    // }
    return {
      title: 'Reset Link Error',
      message: errorMessage || 'There was a problem with your password reset link. Please try again.',
    };
  };

  const errorDetails = getErrorDetails();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-5 py-8">
      <div className="bg-white rounded-3xl p-8 md:p-12 w-full max-w-md text-center shadow-lg">
        <div className="flex justify-center mb-6">
          <img 
            src={Logo} 
            alt="logo" 
            className="w-28 h-auto"
          />
        </div>
        
        <ErrorOutlineIcon 
          className="text-red-400 mb-6" 
          sx={{ fontSize: '80px' }}
        />
        
        <h1 className="text-2xl font-semibold text-gray-800 mb-3">
          {errorDetails.title}
        </h1>
        
        <p className="text-base text-gray-600 mb-8 leading-relaxed">
          {errorDetails.message}
        </p>
        
        <button 
          className="bg-[#52c28c] hover:bg-[#45a876] text-white rounded-full px-10 py-3 text-base font-semibold transition-colors duration-200"
          onClick={handleBackToLogin}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}